// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-qvjrp{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-gefvf{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-eeijt{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bawew{grid-column:span 3}.assets-scss-gridstyleGrid-col4-qyoln{grid-column:span 4}.assets-scss-gridstyleGrid-col9-ehsau{grid-column:span 9}.assets-scss-gridstyleGrid-col12-bwssi{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-bveyl{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-qvjrp",
	"grid": "assets-scss-gridstyleGrid-grid-gefvf",
	"col6": "assets-scss-gridstyleGrid-col6-eeijt",
	"col3": "assets-scss-gridstyleGrid-col3-bawew",
	"col4": "assets-scss-gridstyleGrid-col4-qyoln",
	"col9": "assets-scss-gridstyleGrid-col9-ehsau",
	"col12": "assets-scss-gridstyleGrid-col12-bwssi",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-bveyl"
};
module.exports = ___CSS_LOADER_EXPORT___;
